// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"519":"0a0c23ee842f2707","918":"aa2fad0d146cf775"}[chunkId] + ".js";
};